export default __webpack_public_path__ + "static/media/polygon.9bd3083d.svg";